import React, { Fragment } from 'react';

// Components

import UniversalInput from '@lib/wrappers/UniversalInput';

// Constants

import { DROPDOWN_OPTIONS } from '@constants/ssap/hhmTypes/dropdownOptions';
import { INPUT_TYPES } from '@constants/inputs/inputTypes';
import { VALIDATION_TYPES } from '@constants/inputs/validationTypes';
import { VALIDATION_ERROR_MESSAGES } from '@constants/inputs/validationErrorMessages';
import { omit } from '@utils/miscellaneous/objectHelpers';
import { getAddressLinePoBoxFlags } from '@utils/validators/customValidations';


const OtherAddressInputs = props => {

    const {
        postalCode,
        countyCode,
        streetAddress1,
        streetAddress2,
        state,
        city,
        currentData,
        counties,
        indexInArray,
        isState = {},
        ...restProps
    } = props;

    const getOptions = () => {
        return DROPDOWN_OPTIONS.COUNTIES_FOR_EXACT_ZIPCODE(counties);
    };

    const cleanedRestProps = omit(restProps, 'children');

    const { line1HasPoBoxError, line2HasPoBoxError } = getAddressLinePoBoxFlags(streetAddress1, streetAddress2);

    return (
        <Fragment>
            <UniversalInput
                label={{
                    text: 'ssap.input.label.address_line_one'
                }}
                inputData={{
                    isInputRequired: true,
                    type: INPUT_TYPES.REGULAR_INPUT,
                    name: 'streetAddress1',
                    value: streetAddress1,
                    placeholder: 'ssap.input.placeholder.address_line_one',
                    validationType: VALIDATION_TYPES.HOME_ADDRESS_LINE1,
                    valuesToMatch: { otherLineValue: streetAddress2, isState },
                    validationErrorMessage: line1HasPoBoxError ? VALIDATION_ERROR_MESSAGES.PO_BOX_NOT_PERMITTED : undefined,
                    currentData: currentData,
                    fields: []
                }}
                indexInArray={indexInArray}
                {...cleanedRestProps}
            />
            <UniversalInput
                label={{
                    text: 'ssap.input.label.address_line_two'
                }}
                inputData={{
                    isInputRequired: false,
                    type: INPUT_TYPES.REGULAR_INPUT,
                    name: 'streetAddress2',
                    value: streetAddress2,
                    placeholder: 'ssap.input.placeholder.address_line_two',
                    validationType: VALIDATION_TYPES.HOME_ADDRESS_LINE2,
                    valuesToMatch: { otherLineValue: streetAddress1, isState },
                    validationErrorMessage: line2HasPoBoxError ? VALIDATION_ERROR_MESSAGES.PO_BOX_NOT_PERMITTED : undefined,
                    currentData: currentData,
                    fields: []
                }}
                indexInArray={indexInArray}
                {...cleanedRestProps}
            />
            <UniversalInput
                label={{
                    text: 'ssap.input.label.city'
                }}
                inputData={{
                    isInputRequired: true,
                    type: INPUT_TYPES.REGULAR_INPUT,
                    name: 'city',
                    value: city,
                    placeholder: 'ssap.input.placeholder.city',
                    validationType: VALIDATION_TYPES.CITY,
                    currentData: currentData,
                    fields: []
                }}
                indexInArray={indexInArray}
                {...cleanedRestProps}
            />
            <UniversalInput
                label={{
                    text: 'ssap.input.label.zip'
                }}
                inputData={{
                    isInputRequired: true,
                    type: INPUT_TYPES.REGULAR_INPUT,
                    name: 'postalCode',
                    value: postalCode,
                    placeholder: 'ssap.input.placeholder.zip',
                    validationType: VALIDATION_TYPES.ZIP_CODE_5_DIGITS,
                    currentData: currentData,
                    fields: []
                }}
                indexInArray={indexInArray}
                {...cleanedRestProps}
            />
            <UniversalInput
                label={{
                    text: 'ssap.input.label.state',
                    isLabelRequired: true
                }}
                inputData={{
                    isInputRequired: true,
                    type: INPUT_TYPES.DROPDOWN,
                    name: 'state',
                    value: state,
                    options: DROPDOWN_OPTIONS.STATE,
                    validationType: VALIDATION_TYPES.CHOSEN,
                    currentData: JSON.parse(JSON.stringify(currentData)),
                    fields: []
                }}
                indexInArray={indexInArray}
                {...cleanedRestProps}
            />
            <UniversalInput
                label={{
                    text: 'ssap.input.label.county',
                    isLabelRequired: true
                }}
                inputData={{
                    isInputRequired: true,
                    type: INPUT_TYPES.DROPDOWN,
                    name: 'countyCode',
                    value: countyCode,
                    options: getOptions(),
                    valuesToMatch: counties.map(county => Object.keys(county)[0]),
                    validationType: VALIDATION_TYPES.CHOSEN_FROM_LIST,
                    currentData: currentData,
                    fields: []
                }}
                indexInArray={indexInArray}
                {...cleanedRestProps}
            />
        </Fragment>
    );
};

export default OtherAddressInputs;